import React from "react";
import BaseListPage from "../../../../base/BaseListPage";
import TimePresenter from "./TimePresenter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import { Button, Progress } from "nq-component";
import Table from "../../../../components/Table";
import CardView from "../../../../components/common/CardView";
import TimeFormPage from "./time-form/TimeFormPage";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import PrintDTR from "./print/PrintDTR";
import timesheetSchema from "../../../HumanResource/TimeSheet/TimeSheetTable/timesheet_schema.json";

class TimeTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TimePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
    );
    this.state = {
      objects: [],
      object: {},
      timeForm: false,
      objectID: "",
      printDTR: false,
      month: "",
      year: "",
      count: 0,
      limit: 50,
      current: 1,
      availableMonth: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  }

  getCollectionName() {
    return "biometric_logs";
  }

  getCurrent() {
    return this.getCurrentUser();
  }

  async requestOverTime(id) {
    // await deleteObjectUseCase().execute("daily_time_record", id);
    // this.refetchData();
    this.navigateTo(`/overtime`);
  }

  // edit function
  async handleEditData(id) {
    this.setState({ objectID: id, timeForm: true });
  }
  handleCloseForm() {
    this.setState({ timeForm: false });
  }

  handlePrintDTR() {
    this.setState({ printDTR: true });
  }

  closePrint() {
    this.setState({ printDTR: false });
  }

  handleAccessPass() {
    this.props.accessPass(true);
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }
  async onChangeForm(field, value) {
    this.setState({ [field]: value });
  }

  async handleSearchSubmit() {
    if (this.state.month || this.state.year) {
      const query = {
        where: {
          month: this.state.availableMonth.indexOf(this.state.month),
          year: this.state.year,
        },
        sort: {
          date: 1,
        },
      };
      this.filterSubmit(query.where);
    } else {
      this.filterSubmit();
    }
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = timesheetSchema;
    // const user = this.getCurrentRoles().some((item) => item.id === "user");
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
console.log("schema: ", schema);
    return (
      <>
        <div style={{ marginTop: "1rem", zIndex: 1 }}>
          <div>
            <CardView style={{ borderRadius: 0 }}>
              <form
                className="row"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.handleSearchSubmit();
                }}
              >
                {["Month", "Year"].map((field, index) => {
                  const label = field.toLowerCase();
                  let options;

                  if (label === "year") {
                    options = years.map((item) => ({
                      label: item.toString(),
                      value: item.toString(),
                    }));
                  } else {
                    options = this.state.availableMonth.map((item) => ({
                      label: item.toString(),
                      value: item.toString(),
                    }));
                  }

                  return (
                    <div className="col-lg-5" key={`${label}-${index}`}>
                      <SearchSelect
                        key={label}
                        value={this.state[label]}
                        placeholder={field}
                        required={true}
                        onClickClear={() => this.onChangeForm(label, "")}
                        onChange={(value) => this.onChangeForm(label, value)}
                        options={options}
                      />
                    </div>
                  );
                })}
                <div className="col-lg-2">
                  <button type="submit" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </form>
            </CardView>

            <div
              style={{
                marginTop: "20px",
                width: "100%",
              }}
            >
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex align-items-center justify-content-center">
                  <h4 className="text-primary me-auto">{schema.label}</h4>
                  <div className="d-flex gap-2" style={{ marginLeft: "auto" }}>
                    <Button onClick={this.handlePrintDTR.bind(this)}>
                      View DTR
                    </Button>
                    {/* <Button onClick={this.handleAccessPass.bind(this)}>
                      <i className="bi bi-calendar" /> Access Pass
                    </Button> */}
                  </div>
                </div>
              </CardView>
            </div>

            <Table
              objectId={this.requestOverTime.bind(this)}
              editId={this.handleEditData.bind(this)}
              progress={loading}
              refetch={this.refetchData.bind(this)}
              fields={schema.fields}
              objects={objects}
              collection={schema}
              count={count}
              limit={limit}
              current={current}
              loadPagination={this.onClickPagination.bind(this)}
              excludeFields={Object.keys(schema.fields).reduce(
                (acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                },
                [
                  "basicLateMinutes",
                  "basicUndertimeMinutes",
                  "APlateMinutes",
                  "APundertimeMinutes",
                  "timeAmOutMode",
                  "timeInMode",
                  "timeOutMode",
                  "timePmInMode"
                ],
              )}
              onClickItem={this.onClickItem.bind(this)}
            />
          </div>
          {/* </InfiniteScroll> */}

          {this.state.timeForm && (
            <TimeFormPage
              handleCloseForm={this.handleCloseForm.bind(this)}
              objectID={this.state.objectID}
              objectData={
                objects?.find((o) => o.id === this.state.objectID) ?? {}
              }
              refetchData={this.refetchData.bind(this)}
              employee={this.state.employee}
            />
          )}
        </div>

        {this.state.printDTR && (
          <PrintDTR
            closeAccess={() => this.setState({ printDTR: false })}
            dailyRec={objects}
            watermark={true}
            employee={this.state.employee}
            month={
              this.state.month ||
              new Date().toLocaleString("default", { month: "long" })
            }
            year={this.state.year || new Date().getFullYear().toString()}
            availableMonth={this.state.availableMonth}
          />
        )}
      </>
    );
  }
}

export default TimeTable;
